import script from "./ServicesGridBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesGridBlock.vue?vue&type=script&setup=true&lang=js"

import "./ServicesGridBlock.vue?vue&type=style&index=0&id=dee03c76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dee03c76"]])

export default __exports__